<template>
  <span>{{ formattedTweeningValue }}</span>
</template>

<script>
import _ from 'lodash';
import TWEEN from 'tween';
import moneyUtils from '../utils/money';

export default {
  name: 'AnimatedNumber',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      tweeningValue: 0,
    };
  },
  watch: {
    value(newValue, oldValue) {
      const startValue = _.isNaN(oldValue) ? newValue : oldValue;
      this.tween(startValue, newValue);
    },
  },
  mounted() {
    if (_.isNaN(this.value)) {
      this.tweeningValue = 'NaN';
    } else {
      this.tween(this.value, this.value);
    }
  },
  computed: {
    formattedTweeningValue() {
      if (this.tweeningValue === 'NaN') {
        return '?';
      }
      return moneyUtils.formatAmountWithFraction(this.tweeningValue, 0);
    },
  },
  methods: {
    tween(startValue, endValue) {
      const vm = this;
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }

      new TWEEN.Tween({ tweeningValue: startValue })
        .to({ tweeningValue: endValue }, 1000)
        .onUpdate(function () { // eslint-disable-line
          vm.tweeningValue = this.tweeningValue.toFixed(0);
        })
        .start();

      animate();
    },
  },
};
</script>

<style scoped>

</style>
